import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {WarrantyInformationService} from "./warranty-information.service";
import {WarrantyInformation} from "./warranty-information";
import {WarrantyDto} from "../../../auto-generated-server-dtos/warranty-search/warranty-dto";

@Component({
  selector: 'app-warranty-information',
  templateUrl: './warranty-information.component.html',
  styleUrls: ['./warranty-information.component.css']
})
export class WarrantyInformationComponent implements OnInit, OnChanges {
  @Input() warranty: WarrantyDto | null = null;
  @Input() IsAdjusterView: boolean = false;

  constructor(private warrantyInformationService: WarrantyInformationService) { }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
  }
}
